<!-- app.component.html -->
<div class="loading-overlay" *ngIf="(loadingService.getLoading() | async) && !isUpdateInfoRouter()">
  <div class="loader"></div>
</div>
<router-outlet></router-outlet>
<app-toastr></app-toastr>